import { Base } from "../../framework/base";
import { IdTitleNode, IIdTitleNode } from "../common/idTitleNode";
import { IRecordUnit, RecordUnit } from "../unit/recordUnit";
import { AppReportEventReferenceData, IAppReportEventReferenceData } from "./appReportEventReferenceData";
import { AppReportRecordReferenceData, IAppReportRecordReferenceData } from "./appReportRecordReferenceData";
import { AppReportTaskReferenceData, IAppReportTaskReferenceData } from "./appReportTaskReferenceData";
import { AppReportTemplateEditItem, IAppReportTemplateEditItem } from "./appReportTemplateEditItem";

export interface IAppReportTemplateEdit {
    item: IAppReportTemplateEditItem;
    reportTemplateUnits: IRecordUnit[];
    units: IIdTitleNode[];
    eventReferenceData: IAppReportEventReferenceData;
    taskReferenceData: IAppReportTaskReferenceData;
    recordReferenceData: IAppReportRecordReferenceData;
}

export class AppReportTemplateEdit implements IAppReportTemplateEdit {
    item: AppReportTemplateEditItem;
    reportTemplateUnits: RecordUnit[];
    units: IdTitleNode[];
    eventReferenceData: AppReportEventReferenceData;
    taskReferenceData: AppReportTaskReferenceData;
    recordReferenceData: AppReportRecordReferenceData;

    constructor();
    constructor(obj: IAppReportTemplateEdit);
    constructor(obj?: any) {
        this.item = new AppReportTemplateEditItem(obj ? obj.item : null);
        this.reportTemplateUnits = Base.getTypedArray(obj?.reportTemplateUnits, RecordUnit);
        this.units = Base.getTypedArray(obj ? obj.units : null, IdTitleNode);
        this.eventReferenceData = new AppReportEventReferenceData(obj.eventReferenceData);
        this.taskReferenceData = new AppReportTaskReferenceData(obj.taskReferenceData);
        this.recordReferenceData = new AppReportRecordReferenceData(obj.recordReferenceData);
    }
}